import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Event from '../components/Event';
import { getPlayerNames } from './index.js';

function Playground() {
  const location = useLocation();
  const reduxSport = useSelector((state) => state.sport);
  const { user, isDemo } = useSelector((state) => state.auth);

  // Use location.state if available, otherwise fallback to redux
  const data = location.state || reduxSport;

  const {
    sportCategory,
    eventId,
    team1Idx,
    startPos,
    primaryColor,
    secondaryColor,
    editPrimaryTeam,
    payout,
    closetScorePair,
    playerNames,
    point,
    isFree,
    player1Name,
    player2Name,
    player3Name,
    player4Name,
  } = data;

  const [tabStatus, setTabStatus] = useState(true);

  const [p1, setP1] = useState(player1Name || 'P1');
  const [p2, setP2] = useState(player2Name || 'P2');
  const [p3, setP3] = useState(player3Name || 'P3');
  const [p4, setP4] = useState(player4Name || 'P4');

  useEffect(() => {
    if (!player1Name || !player2Name || !player3Name || !player4Name) {
      // fallback: generate names if not present
      const names = getPlayerNames(startPos, user?.name || '', payout);
      setP1(names.name1);
      setP2(names.name2);
      setP3(names.name3);
      setP4(names.name4);
    }
  }, [player1Name, player2Name, player3Name, player4Name, startPos, user, payout]);

  const handleTeamName = (value, index) => {
    switch (index) {
      case 1:
        setP1(value);
        break;
      case 2:
        setP2(value);
        break;
      case 3:
        setP3(value);
        break;
      case 4:
        setP4(value);
        break;
      default:
        break;
    }
  };

  const handleTab = () => {
    setTabStatus(!tabStatus);
  };

  return (
    <>
      <Event
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        tabStatus={tabStatus}
        sportCategory={sportCategory}
        team1Idx={parseInt(team1Idx)}
        startPos={parseInt(startPos)}
        eventId={eventId}
        isDemo={isDemo}
        isFree={isFree}
        point={point}
        payout={payout}
        editPrimaryTeam={editPrimaryTeam}
        handleTab={handleTab}
        handleTeamName={handleTeamName}
        closetScorePair={closetScorePair}
        playerNames={playerNames}
        player1Name={p1 ? p1 : '-'}
        player2Name={p2 ? p2 : '-'}
        player3Name={p3 ? p3 : '-'}
        player4Name={p4 ? p4 : '-'}
      />
    </>
  );
}

export default Playground;